import { render, staticRenderFns } from "./vehicleUpdation.vue?vue&type=template&id=7521c7c2"
import script from "./vehicleUpdation.vue?vue&type=script&lang=js"
export * from "./vehicleUpdation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports